
const 	llpAndConsentWrap = document.querySelectorAll('.js-llp-and-consent');

llpAndConsentWrap.forEach( item => {
	
	const 	llpCheckboxWrap = item.querySelector('.js-llp-checkbox'),
			consentCheckboxWrap = item.querySelector('.js-consent-checkbox'),

			llpCheckbox = (llpCheckboxWrap) ? llpCheckboxWrap.querySelector('input[type=checkbox]') : null,
			consentCheckbox = (consentCheckboxWrap) ? consentCheckboxWrap.querySelector('input[type=checkbox]') : null;

	function hideConsentCheckbox() {
		consentCheckboxWrap.style.display = 'none';
	}

	function showConsentCheckbox() {
		consentCheckboxWrap.style.display = 'block';
	}

	llpCheckbox.addEventListener( 'change', e => {
		e.target.checked ? showConsentCheckbox() : hideConsentCheckbox();
	});

	hideConsentCheckbox();
});